import * as api from "../Api";

export const allExhaustedAssets = () => async (dispatch) => {
  try {
    const { data } = await api.exhaustedAsset();
    dispatch({ type: "GET_ALL_EXHAUSTED_ASSETS", payload: data });
  } catch (error) {}
};
